import React from 'react';

import { BasketTotalsSegments } from './BasketTotalsSegments';
import classes from './BasketSummary.scss';
import { SummaryPromise } from './SummaryPromise';
import { SummaryActions } from './SummaryActions';

type BasketSummaryProps = {
    isPending: boolean;
};

export const BasketSummary: React.FC<BasketSummaryProps> = React.memo((props) => {
    return (
        <div className={classes.summary}>
            <h2 className={classes.summaryTitle}>Your order summary</h2>
            <BasketTotalsSegments />
            <SummaryPromise location="basket" />
            <fieldset disabled={props.isPending}>
                <SummaryActions />
            </fieldset>
        </div>
    );
});
